import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel'];

  declare readonly panelTarget: HTMLElement;

  toggle() {
    this.panelTarget.classList.toggle('hidden');
  }
}
